import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Palette, BookHeart, Puzzle, Bookmark, PencilRuler, Sparkles, Star } from 'lucide-react';
interface CollectionCardProps {
  number: string;
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  title: string;
  benefit: string;
}
function CollectionCard({
  number,
  icon,
  iconBg,
  iconColor,
  title,
  benefit
}: CollectionCardProps) {
  return <div className="bg-white rounded-xl p-5 shadow-sm h-full flex flex-col transition-transform duration-300 hover:-translate-y-1" style={{
    borderColor: 'var(--color-border)',
    borderWidth: '1px'
  }} data-id="element-24">
      <div className="flex items-center gap-3 mb-3" data-id="element-25">
        <span className="text-sm font-bold opacity-30" style={{
        color: 'var(--color-deep-blue)'
      }} data-id="element-26">
          {number}
        </span>
        <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
        backgroundColor: iconBg
      }} data-id="element-27">
          <span style={{
          color: iconColor
        }} data-id="element-28">
            {icon}
          </span>
        </div>
        <h3 className="text-base font-bold leading-tight" style={{
        color: 'var(--color-deep-blue)'
      }} data-id="element-29">
          {title}
        </h3>
      </div>
      <p className="text-sm font-medium leading-relaxed mt-auto" style={{
      color: 'var(--color-body)'
    }} data-id="element-30">
        {benefit}
      </p>
    </div>;
}
export function CollectionSection() {
  return <section id="coleccion" className="py-12 md:py-16" style={{
    backgroundColor: 'var(--color-off-white)'
  }} data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <FadeIn data-id="element-33">
          <div className="text-center mb-10" data-id="element-34">
            <h2 className="text-2xl md:text-4xl font-bold mb-3" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-35">
              Todo lo que incluye esta colección
            </h2>
          </div>
        </FadeIn>

        {/* Featured Main Resource */}
        <div className="max-w-5xl mx-auto mb-6" data-id="element-36">
          <FadeIn delay={0} data-id="element-37">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border-2 relative overflow-hidden" style={{
            borderColor: 'var(--color-gold)'
          }} data-id="element-38">
              <div className="absolute top-4 right-4 bg-[#FEF6E8] px-3 py-1 rounded-full border border-[#FDE6B5] flex items-center gap-1.5" data-id="element-39">
                <Star className="w-3.5 h-3.5 fill-current" style={{
                color: 'var(--color-gold)'
              }} data-id="element-40" />
                <span className="text-xs font-bold uppercase tracking-wider" style={{
                color: 'var(--color-gold)'
              }} data-id="element-41">
                  Recurso Principal
                </span>
              </div>

              <div className="flex flex-col md:flex-row items-start gap-5 md:gap-8 mt-4 md:mt-0" data-id="element-42">
                <div className="flex items-center gap-4 mb-2 md:mb-0 md:w-1/3" data-id="element-43">
                  <span className="text-3xl font-black opacity-20" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-44">
                    01
                  </span>
                  <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#FEF6E8'
                }} data-id="element-45">
                    <BookHeart className="w-7 h-7" style={{
                    color: 'var(--color-gold)'
                  }} data-id="element-46" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold leading-tight" style={{
                  color: 'var(--color-deep-blue)'
                }} data-id="element-47">
                    10 libros de parábolas para niños
                  </h3>
                </div>
                <div className="md:w-2/3" data-id="element-48">
                  <p className="text-base md:text-lg leading-relaxed mb-4 font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-49">
                    Historias organizadas para acompañar a los niños en
                    diferentes momentos, con enseñanzas y preguntas que ayudan a
                    reflexionar, aprender y crecer en la fe.
                  </p>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-50">
                    {['Distintas temáticas para diferentes momentos', 'Enseñanzas claras y adaptadas para niños', 'Preguntas para reflexionar y conversar', 'Ideal para familia, iglesia o aula'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-51">
                        <Sparkles className="w-4 h-4 mt-1 flex-shrink-0" style={{
                      color: 'var(--color-gold)'
                    }} data-id="element-52" />
                        <span className="text-sm font-bold" style={{
                      color: 'var(--color-deep-blue)'
                    }} data-id="element-53">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Other 6 Resources Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto mb-10" data-id="element-54">
          <FadeIn delay={0.1} data-id="element-55">
            <CollectionCard number="02" icon={<Palette className="w-5 h-5" data-id="element-57" />} iconBg="#EAF2F8" iconColor="var(--color-soft-blue)" title="Biblia para colorear" benefit="Para que aprendan mientras se divierten coloreando escenas bíblicas." data-id="element-56" />
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-58">
            <CollectionCard number="03" icon={<BookHeart className="w-5 h-5" data-id="element-60" />} iconBg="#FDF2EC" iconColor="var(--color-soft-peach)" title="Devocional familiar" benefit="Reflexiones simples para compartir momentos de conexión con Dios en familia." data-id="element-59" />
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-61">
            <CollectionCard number="04" icon={<Puzzle className="w-5 h-5" data-id="element-63" />} iconBg="#F0F7F2" iconColor="var(--color-green)" title="Juego cristiano imprimible" benefit="Un recurso lúdico para enseñar valores y símbolos cristianos jugando." data-id="element-62" />
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-64">
            <CollectionCard number="05" icon={<Bookmark className="w-5 h-5" data-id="element-66" />} iconBg="#FEF6E8" iconColor="var(--color-gold)" title="Versículos para memorizar" benefit="Tarjetas con versículos fáciles y significativos para que los niños los recuerden." data-id="element-65" />
          </FadeIn>
          <FadeIn delay={0.5} data-id="element-67">
            <CollectionCard number="06" icon={<PencilRuler className="w-5 h-5" data-id="element-69" />} iconBg="#EEF0F8" iconColor="#7B8EC4" title="Actividades cristianas" benefit="Ejercicios y dinámicas listas para imprimir y reforzar enseñanzas bíblicas." data-id="element-68" />
          </FadeIn>
          <FadeIn delay={0.6} data-id="element-70">
            <CollectionCard number="07" icon={<Sparkles className="w-5 h-5" data-id="element-72" />} iconBg="#FDF8F2" iconColor="var(--color-gold)" title="Cuaderno de oración" benefit="Un espacio guiado para que los niños aprendan a expresar sus oraciones a Dios." data-id="element-71" />
          </FadeIn>
        </div>

        {/* Value Summary Box */}
        <FadeIn delay={0.7} data-id="element-73">
          <div className="max-w-4xl mx-auto bg-white rounded-xl p-6 md:p-8 text-center border shadow-sm mb-10" style={{
          borderColor: 'var(--color-border)',
          backgroundColor: 'var(--color-cream-warm)'
        }} data-id="element-74">
            <h4 className="text-lg font-bold mb-3" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-75">
              En resumen:
            </h4>
            <p className="text-base md:text-lg font-medium leading-relaxed mb-4" style={{
            color: 'var(--color-body)'
          }} data-id="element-76">
              +500 parábolas · 10 libros temáticos · Biblia para colorear ·
              Devocional familiar · Juego imprimible · Versículos para memorizar
              · Actividades cristianas · Cuaderno de oración
            </p>
            <div className="inline-block px-4 py-1.5 rounded-full bg-white border font-bold text-sm" style={{
            borderColor: 'var(--color-gold)',
            color: 'var(--color-gold)'
          }} data-id="element-77">
              Todo en un solo pack. Listo para descargar y usar hoy.
            </div>
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.8} data-id="element-78">
          <div className="flex justify-center" data-id="element-79">
            <a href="#comprar" className="inline-flex items-center justify-center text-center px-12 py-4 text-lg font-bold text-white rounded-full transition-all duration-300 hover:-translate-y-1" style={{
            backgroundColor: 'var(--color-gold)',
            boxShadow: '0 4px 20px rgba(201,150,59,0.4)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold-hover)';
            e.currentTarget.style.boxShadow = '0 6px 25px rgba(201,150,59,0.5)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(201,150,59,0.4)';
          }} data-id="element-80">
              OBTENER LA COLECCIÓN COMPLETA
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}